import { capitalize } from "@helper/stringTransform";
import {
  DEFAULT_OG_IMAGE_HEIGHT,
  DEFAULT_OG_IMAGE_WIDTH,
  getSectionOgImageUrl,
} from "@src/app/config/ogImageConstants";
import type { GADataProps } from "@typings/GA";
import type { MetaTagsProps } from "@typings/MetaTags";
import type { PageMetaDataValues } from "@typings/PageMetaData";

export default function WebinarMetaData(section: string): PageMetaDataValues {
  const gaData: GADataProps = {
    level2: section,
    title: `${capitalize(section)}_Index`,
    section: section,
    contentcat: "1",
    contenttype: "webinar",
  };

  const metaTags: MetaTagsProps = {
    title: "Webinar, Berita - Beritaharian.sg",
    description: "Sertai acara webinar anjuran Berita Harian",
    slug: `/${section}`,
    ogImage: {
      url: getSectionOgImageUrl("webinar"),
      width: DEFAULT_OG_IMAGE_WIDTH,
      height: DEFAULT_OG_IMAGE_HEIGHT,
    },
  };

  return {
    gaData,
    metaTags,
  };
}
